import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
const AdminChangePassword = (props) => {
  const user = props.user;
  const [values, setValues] = useState({
    newPassword: "",
  });

  const submitChangePassword = props.submitChangePassword;
  const onNewPasswordChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const saveNewPassword = (e, userId, username, newPassword) => {
    e.preventDefault();

    //Call backend change password...
    submitChangePassword(e, userId, username, newPassword);
  };

  return (
    <div
      style={{
        position: "fixed",
        width: "100%",
        height: "100%",
        top: "0",
        left: "0",
      }}
    >
      <Dialog open={props.isPwdChangeOpen}>
        <form
          autoComplete="new-password"
          onSubmit={(e) =>
            saveNewPassword(e, user._id, user.username, values.newPassword)
          }
        >
          <DialogContent>
            <h5>Update password for {user.username}</h5>
            <br></br>
            <p>
              {" "}
              *** Please make a note of the new password since after you have
              saved there is no way to retrive it.
            </p>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "400px",
              }}
            >
              <TextField
                type="password"
                name="newPassword"
                label="New password"
                onChange={onNewPasswordChange}
                className="form-control"
                placeholder="Password"
                textContentType="none"
                autoComplete="new-password"
                style={{ margin: "5px 5px", backgroundColor: "#FAFAFA"   }}
                required
              />
            </div>
          </DialogContent>
          <DialogActions>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                margin: "0 auto",
              }}
            >
              <Button
                type="submit"
                color="primary"
                variant="contained"
                style={{
                  marginTop: "10px",
                  position: "inherit",
                  justifyContent: "center",
                  textAlign: "center",
                  color: "white",
                  marginLeft: "15px",
                  width: "100px",
                }}
              >
                Save
              </Button>

              <Button
                color="secondary"
                variant="contained"
                style={{
                  marginTop: "10px",
                  position: "inherit",
                  justifyContent: "center",
                  textAlign: "center",
                  color: "white",
                  width: "100px",
                  marginLeft: "15px",
                }}
                onClick={() => props.handleCancel()}
              >
                {props.cancelText}
              </Button>
            </div>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

export default AdminChangePassword;
